import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import { DetailsPageHeader } from 'components';

let PaymentDetails = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Payment details'>
            {service.order.payment &&
                <Grid container>
                    <Grid item xs={3}>
                        <Typography>Payment title</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.payment.paymentTitle}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Payment status</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.payment.paymentStatus}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography>Notes</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography>{service.order.payment.notes}</Typography>
                    </Grid>
                </Grid>
            }
        </DetailsPageHeader>
    );
}

export default PaymentDetails;